module.exports = __webpack_public_path__ + "static/img/irole.3192b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/swbnzk/irole.png
// module id = LW/W
// module chunks = 7